import React from "react";
import { Link } from "react-router-dom";
// import ReactTextCollapse from "react-icon-collapse";
import Typography from "@mui/material/Typography";
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";

import QuickView from "./quick_view/QuickView";

import RepoIconImg from "./RepoIconImg";
import {OpenInNew} from '@mui/icons-material';

/*const TEXT_COLLAPSE_OPTIONS = {
    collapse: false,
    collapseText: '... show more',
    expandText: 'show less',
    minHeight: 90,
    maxHeight: 200,
    textStyle: {
        color: 'blue',
        fontSize: '20px',
    },
};*/

const RepositoryCard = ({ repository, compareIds, handleAddToCompare, ...props }) => {
    //// console.log("Props: ");
    //// console.log(props);
    //// console.log(repository);
    const isCompareDisabled = () => {
        return compareIds.length >= 3 && !compareIds.includes(repository['name']);
    }
    
    return (
        <Grid container spacing={1} className='repository-card'>
            <Grid >
                <Link to={'/repositories/' + repository['id']}>
                    <RepoIconImg altText={repository.name + " logo"}
                    imageUri={'repo_logos/' + repository.name + '.png'}/>
                </Link>
            </Grid>

            <Grid xs={11}>
                <div style={{ float: 'right'}}>
                    <FormGroup>
                        <FormControlLabel 
                            label="Compare"
                            control={
                                <Checkbox
                                    disabled={isCompareDisabled()}
                                    onChange={handleAddToCompare}
                                    id={repository['name']}
                                    checked={compareIds.includes(repository['name'])}  // Add this line
                                />
                            }
                        />
                    </FormGroup>
                </div>

                <Link to={'/repositories/' + repository['id']}>
                    {repository['nickname']
                        ? <><Typography className="repository-name" color="text.primary" gutterBottom>
                            {repository['name']} ({repository['nickname']})
                        </Typography></>
                        : <><Typography className="repository-name" color="text.primary" gutterBottom>
                            {repository['name']}
                        </Typography></>
                    }
                </Link>

                {(repository.affiliations && repository.affiliations.length) && repository.affiliations.map(affiliation =>
                    <Typography key={repository.id + '-affiliation-' + affiliation.id} variant='body2'>
                        <b>Affiliation</b>: {affiliation['name']}
                    </Typography>
                )}
            </Grid>

            <Grid xs={12} container direction="column">
                <Grid xs={12} style={{ margin: '10px 0', display: 'flex' }}>
                    <div style={{ minWidth: '100px', paddingTop: '9px' }}><b>Organisms: </b></div>
                    <div>
                    {repository?.organisms?.map(organism =>
                        <Chip className='repository-chip' 
                                style={{ backgroundColor: '#D3F1FF' }} 
                                key={'chip-' + repository.id + '-organism-' + organism.id} 
                                label={organism['name']} />
                    )}
                    </div>
                </Grid>

                <Grid xs={12} style={{ marginBottom: '10px', display: 'flex' }}>
                    <div style={{ minWidth: '100px', paddingTop: '9px' }}><b>Research Areas: </b></div>
                    <div>
                    {repository?.research_areas?.map(research_area =>
                        <Chip className='repository-chip' 
                                style={{ backgroundColor: '#D3F1FF' }} 
                                key={'chip-' + repository.id + '-ra-' + research_area.id} 
                                label={research_area['name']} />
                    )}
                    </div>
                </Grid>

                <Grid xs={12} style={{ marginBottom: '20px', display: 'flex' }}>
                    <div style={{ minWidth: '100px', paddingTop: '9px' }}><b>Data Types: </b></div>
                    <div>
                        {repository?.data_types?.map(data_type =>
                            <Chip className='repository-chip' 
                                    style={{ backgroundColor: '#D3F1FF' }} 
                                    key={'chip-' + repository.id + '-dt-' + data_type.id} 
                                    label={data_type['name']} />
                        )}
                    </div>
                </Grid>

                <Grid xs={12} className='repository-card-description'>
                    <Typography variant="value" >
                        {repository['description']}
                    </Typography>
                </Grid>
            </Grid>

            <QuickView repository={repository} split={true} />

            <Grid xs={12} container className="repository-card-buttons">

                 <div>
                    <Link to={'/repositories/' + repository['id']}>
                        <Button size="small" variant="contained" fullWidth className="large-button">View Repository Details</Button>
                    </Link>
                </div>

                <div>
                    <a href={repository['url']} target="_blank" rel="noreferrer">
                        <Button size="small" fullWidth variant="text" endIcon={<OpenInNew/>} className="text-button">
                            <b>Repository Homepage</b>
                        </Button>
                    </a>
                </div>

                { repository.fairsharing_url &&
                    <div>
                        <a href={repository['fairsharing_url']} target="_blank" rel="noreferrer">
                            <Button size="small" fullWidth variant="text" endIcon={<OpenInNew/>} className="text-button">
                                <b>Visit on FAIRsharing</b>
                            </Button>
                        </a>
                    </div>
                }


            </Grid>
        </Grid>
    );
}

export default RepositoryCard;